
import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Fido from '../../utils/Fido';
import OverviewReportLayout from "../components/OverviewReportLayout";
import Constants from '../../utils/Constants';
import AuthorizedUserContext from "../../utils/AuthorizedUserContext";
import ReportScreenShot from "../components/ReportScreenShot";
import WebSearchSparkCards from "../../assets/screen-shots/web-search-spark-cards.png";
import WebSearchScannedVsAlerts from "../../assets/screen-shots/web-search-scanned-vs-alerts.png";
import WebSearchRecentAlerts from "../../assets/screen-shots/web-search-recent-alerts.png";
import WebSearchTopAuthors from "../../assets/screen-shots/web-search-top-authors.png";
import WebSearchTopSearchEngines from "../../assets/screen-shots/web-search-top-search-engines.png";

class StaticWebSearchOverviewReport extends Component {
	constructor(props, context) {
		super(props, context);

		let {location, days, source, authenticatedUser} = this.props,
			accountParam = Fido.getSearchParam("account", location.search);

		this.state = {
			filter: {
				account: accountParam ? (accountParam.split(",")).map(item => Number(item)) : authenticatedUser.childAccounts.map(item => item.id),
				previousDays: Number(Fido.getSearchParam("previousDays", location.search)) || days,
				source: Fido.getSearchParam("source", location.search) || source
			}
		};
	}

	componentDidMount() {
		this.setupReport();
	}

	componentDidUpdate(prevProps, prevState) {
		if (prevProps.source !== this.props.source) {
			this.setState({
				filter: {
					account: this.state.filter.account,
					previousDays: this.state.filter.previousDays,
					source: this.props.source,
				}
			}, () => {
				this.setupReport();
			});
		}
	}

	setupReport() {
		this.props.updateHeader({title: Constants.SOURCES.DISPLAY_NAMES[this.state.filter.source], primary: true});
	}

	render() {
		let {filter} = this.state,
			previousDays = filter.previousDays;

		return (
			<OverviewReportLayout
				location={this.props.location}
				previousDays={previousDays}
				filterCallback={() => {}}
				selectedAccounts={filter && filter.account}>
				<ReportScreenShot noPaper fullWidth key="sskey1" image={WebSearchSparkCards} />
				<ReportScreenShot fullWidth key="sskey2" image={WebSearchScannedVsAlerts} />
				<ReportScreenShot key="sskey3" image={WebSearchTopAuthors} />
				<ReportScreenShot key="sskey4" image={WebSearchTopSearchEngines} />
				<ReportScreenShot key="sskey5" image={WebSearchRecentAlerts} />
			</OverviewReportLayout>
		);
	}
}

StaticWebSearchOverviewReport.defaultProps = {
	days: 30
};

StaticWebSearchOverviewReport.propTypes = {
	location: PropTypes.object.isRequired,
	history: PropTypes.object.isRequired,
	days: PropTypes.number,
	source: PropTypes.string,
	updateHeader: PropTypes.func,
	resetHeader: PropTypes.func,
	showSnackbar: PropTypes.func,
	authenticatedUser: PropTypes.oneOfType([PropTypes.bool, PropTypes.object]).isRequired
};

// eslint error
const dNameFunc = (props, ref) => (
	<AuthorizedUserContext.Consumer>
		{authenticatedUser => <StaticWebSearchOverviewReport {...props} authenticatedUser={authenticatedUser} ref={ref} />}
	</AuthorizedUserContext.Consumer>
);
dNameFunc.displayName = "StaticWebSearchOverviewReport";

export default (React.forwardRef(dNameFunc));